import {latitudeSchema} from '@gaia/types/schemas/latitudeSchema';
import {latLngSchema} from '@gaia/types/schemas/latLngSchema';
import {lngLatSchema} from '@gaia/types/schemas/lngLatSchema';
import {longitudeSchema} from '@gaia/types/schemas/longitudeSchema';
import {zoomSchema} from '@gaia/types/schemas/zoomSchema';
import type {z} from 'zod';

export function isValidLat(lat: unknown): lat is z.infer<typeof latitudeSchema> {
    return latitudeSchema.safeParse(lat).success;
}

export function isValidLng(lng: unknown): lng is z.infer<typeof longitudeSchema> {
    return longitudeSchema.safeParse(lng).success;
}

export function isValidLngLat(coords: unknown): coords is z.infer<typeof lngLatSchema> {
    return lngLatSchema.safeParse(coords).success;
}

export function isValidLatLng(coords: unknown): coords is z.infer<typeof latLngSchema> {
    return latLngSchema.safeParse(coords).success;
}

export function isValidZoom(zoom: unknown): zoom is z.infer<typeof zoomSchema> {
    return zoomSchema.safeParse(zoom).success;
}
